import Immutable from 'seamless-immutable';
import _ from 'lodash';

import { baseCollection } from '../../common/collections';
import RulesetModel from './ruleset-model';

/**
 * Transforms an array of backend ruleset objects into a RulesetCollection
 * @param {Object[]} rulesets - backend formatted rulesets
 * @returns {Ruleset[]}
 */
const deserialize = (rulesets = []) => Immutable(_.map(rulesets, RulesetModel.deserialize));

/**
 * Transforms a RulesetCollection into an array of backend ruleset objects
 * @param {Ruleset[]} rulesets
 * @returns {Object[]}
 */
const serialize = (rulesets) => _.map(rulesets, (ruleset) => RulesetModel.serialize(ruleset));

export default {
  ...baseCollection,
  create: deserialize,
  deserialize,
  serialize,
};
